import React, { ComponentType } from "react";
import BGIcon from "../../Assets/BGIcon.svg";
import Styled from "./style";

const withBGIcon= <P extends object>(
  WrappedComponent: ComponentType<P>
): React.FC<P> => {
  const WithBackgroundImage: React.FC<P> = ({ ...props }) => {
    return (
      <Styled.Background>
        <Styled.WrappedComponent>
          <WrappedComponent {...(props as P)} />
        </Styled.WrappedComponent>
      </Styled.Background>
    );
  };

  return WithBackgroundImage;
};

export default withBGIcon;
